'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import TeamList from '@/components/AboutUsPage/Team/TeamList';
import TitleGraffiti from '@/components/shared/TitleGraffiti';
import css from './style.module.scss';
import { TeamDto } from './types';
interface Props {
  data: TeamDto;
}
const Team = t0 => {
  const $ = _c(9);
  const {
    data
  } = t0;
  const wrapperRef = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const video = wrapperRef.current?.querySelector("video");
      if (video) {
        video.playbackRate = 0.5;
      }
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== data.title) {
    t3 = <TitleGraffiti className={css.titleWrapper} url="/assets/video/mp4/qream-graffiti.mp4" title={data.title} />;
    $[2] = data.title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== data) {
    t4 = <TeamList data={data} />;
    $[4] = data;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <section ref={wrapperRef} className={css.wrapper}>{t3}{t4}</section>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export default Team;